import { combineReducers, createSlice } from '@reduxjs/toolkit';
import productFiltersSlice from './productFiltersSlice';
import vehicleFiltersSlice from './vehicleFiltersSlice';

const filtersSlice = combineReducers({
	vehicle: vehicleFiltersSlice,
	product: productFiltersSlice,
});

const initialState = {
	isLoading: false,
};

const searchSlice = createSlice({
	name: 'newOrder/productsSearch/vehicleFilters',
	initialState,
	reducers: {
		setIsLoading(state, { payload: isLoading }) {
			return {
				...state,
				isLoading,
			};
		},
	},
});

export { initialState };
export const { setIsLoading } = searchSlice.actions;

export default combineReducers({
	filters: filtersSlice,
	search: searchSlice.reducer,
});
